import React from 'react';
import { Container, Box, Typography, Button, Grid } from '@mui/material';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { CommonHeading, CommonTitle, DesignBtn } from '../../../../layout/Common';
import { useTheme } from '@emotion/react';

const images = [
    {
        img: '/images/TailorsDesigners/TailorsDesigners1.jpg'
    },
    {
        img: '/images/TailorsDesigners/TailorsDesigners1.jpg'
    },
    {
        img: '/images/TailorsDesigners/TailorsDesigners1.jpg'
    },

];

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1
          }
        }
      ]
};

function TailorsDesigners() {
    const theme = useTheme();

    return (
        <Box sx={{
            backgroundImage: 'url(/images/TailorsDesigners/bgimage.jpg)',
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            position: 'relative',
            zIndex: '1',
            padding:'150px 0px',
            backgroundAttachment: 'fixed',
            '&::before': {
                content: '""',
                position: 'absolute',
                width: '100%',
                height: '100%',
                zIndex: '-1',
                backgroundColor: '#000000d9',
                top: '0'
            }}}>
            <Container maxWidth="xl">   
                <Grid container >
                    <Grid xs={12} md={6} lg={4}>
                        <Box sx={{width:{md:'80%',xs:'100%'}}}>
                        <CommonTitle margin={'10px 0'} text={'Tailors & Designers'} />
                        <CommonHeading margin={'0 0 20px 0'} text={'Our varied fashion business is value-driven'} />
                        <Typography variant='p' sx={{ color: '#fff', fontFamily: theme.palette.typography.fontFamily1, mt: 2, fontSize: '16px', lineHeight: 1.8 }}>
                            Sollicitudin ac orci phasellus egestas tellus. Amet nisl purus in mollis nunc sed id. Cursus eget nunc scelerisque viverra mauris in aliquam.
                        </Typography>
                        <Box sx={{width:'60%',mt:5}}>
                        <DesignBtn text={"Book Your Trainers"} />

                        </Box>
                        

                        </Box>
                    </Grid>
                    <Grid xs={12}  md={6} lg={8}>
                        <Box sx={{mt:{xs : 10,md:0}}}>
                            <Slider {...settings}>
                                {images.map((image, index) => (
                                    <div key={index}>
                                        <img src={image.img} alt={`slide ${index}`} style={{ width: '100%', borderRadius: '8px' }} />
                                    </div>
                                ))}
                            </Slider>
                        </Box>

                    </Grid>

                </Grid>

            </Container>
        </Box>
    );
}

export default TailorsDesigners;
